import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import { VariableSizeList } from 'react-window';
import AutoResizer from 'react-virtualized-auto-sizer';
import { consumeTheme } from '../../utils/theme';
import dayjs from 'dayjs';
import DateTBody from './rc-calendar/date/DateTBody';
import { getMonthDiff, getMonthCalendarRows } from './util';
import { i18n } from '../../common/locale';
var TOTAL_MONTHS = 1000;
var CALENDAR_ROW_HEIGHT = 52;
var MONTH_TITLE_HEIGHT = 40;
var MONTH_ESTIMATED_HEIGHT = MONTH_TITLE_HEIGHT + CALENDAR_ROW_HEIGHT * 5;
var MonthVirtualList = (function (_super) {
    __extends(MonthVirtualList, _super);
    function MonthVirtualList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listRef = React.createRef();
        _this.initAnchorMonth = _this.props.selectedValue[0] || dayjs();
        _this.initAnchorIndex = TOTAL_MONTHS / 2 >> 0;
        _this.getHeightByIndex = function (index) {
            var month = _this.listIndexToMonth(index);
            var rows = getMonthCalendarRows(month);
            return MONTH_TITLE_HEIGHT + rows * CALENDAR_ROW_HEIGHT;
        };
        _this.themedRender = function (classNames) {
            return (h(AutoResizer, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (h(VariableSizeList, { width: width, height: height, itemCount: TOTAL_MONTHS, itemSize: _this.getHeightByIndex, estimatedItemSize: MONTH_ESTIMATED_HEIGHT, ref: _this.listRef }, function (_a) {
                    var index = _a.index, style = _a.style;
                    return (_this.renderSingleMonth(classNames, _this.listIndexToMonth(index), style));
                }));
            }));
        };
        return _this;
    }
    MonthVirtualList.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.scrollToCurrent();
        }, 0);
    };
    MonthVirtualList.prototype.scrollToCurrent = function () {
        var _a;
        var index = this.monthToListIndex(this.initAnchorMonth);
        (_a = this.listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(index, 'center');
    };
    MonthVirtualList.prototype.monthToListIndex = function (month) {
        return this.initAnchorIndex + getMonthDiff(this.initAnchorMonth, month);
    };
    MonthVirtualList.prototype.listIndexToMonth = function (index) {
        var indexDiff = index - this.initAnchorIndex;
        return this.initAnchorMonth.add(indexDiff, 'month');
    };
    MonthVirtualList.prototype.renderSingleMonth = function (classNames, month, style) {
        var _a = this.props, prefixCls = _a.prefixCls, selectedValue = _a.selectedValue, onSelect = _a.onSelect;
        return (h("div", { className: classNames(prefixCls + "-month"), style: style },
            h("div", { className: classNames(prefixCls + "-month-title") }, month.format(i18n('yearMonthFormat'))),
            h(DateTBody, { value: month, selectedValue: selectedValue, onSelect: onSelect })));
    };
    MonthVirtualList.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return MonthVirtualList;
}(React.Component));
export default MonthVirtualList;
